import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ChevronLeft, ChevronRight, Gamepad2 } from 'lucide-react';
import type { Game } from '../../shared/types';
import { useTheme } from '../theme';
import { GameCard } from './GameCard';
import { AtlasGameCard } from './AtlasGameCard';
import './latest-games.css';

export function HomeGameShelf({id,title,games,href,linkLabel,showRelease=false,expanded=false,emptyText='暂无游戏',retry}:{
  id:string;title:string;games:Game[];href:string;linkLabel:string;showRelease?:boolean;expanded?:boolean;emptyText?:string;retry?:()=>void;
}) {
  const {pageStyle}=useTheme();
  const track=useRef<HTMLDivElement>(null);
  const [scroll,setScroll]=useState({overflow:false,start:true,end:true});
  useEffect(()=>{
    const el=track.current;if(!el)return;
    const measure=()=>setScroll({overflow:el.scrollWidth>el.clientWidth+2,start:el.scrollLeft<2,end:el.scrollLeft+el.clientWidth>=el.scrollWidth-2});
    const observer=new ResizeObserver(measure);observer.observe(el);
    el.addEventListener('scroll',measure,{passive:true});measure();
    return ()=>{observer.disconnect();el.removeEventListener('scroll',measure);};
  },[games.length,pageStyle]);
  function move(direction:number){
    const el=track.current;if(!el)return;
    el.scrollBy({left:direction*(el.clientWidth-40),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  return <section className={`latest-games home-game-shelf${expanded ? " home-game-grid" : ""}`} id={id} aria-labelledby={`${id}-title`}>
    <header className="latest-games-heading">
      <h2 id={`${id}-title`}>{title}</h2>
      <div className="game-shelf-actions">
        {!expanded && scroll.overflow && <div className="game-shelf-arrows" aria-label={`${title}翻页`}>
          <button aria-label={`${title}向左滑动`} aria-controls={`${id}-track`} disabled={scroll.start} onClick={()=>move(-1)}><ChevronLeft size={18}/></button>
          <button aria-label={`${title}向右滑动`} aria-controls={`${id}-track`} disabled={scroll.end} onClick={()=>move(1)}><ChevronRight size={18}/></button>
        </div>}
        <Link to={href}>{linkLabel}<ArrowUpRight size={18}/></Link>
      </div>
    </header>
    {games.length ? <div ref={track} id={`${id}-track`} className="latest-games-grid" tabIndex={!expanded && scroll.overflow?0:undefined} aria-label={`${title}列表`} onKeyDown={e=>{
      if(expanded || e.target!==e.currentTarget)return;
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}
    }}>
      {games.map(game=>pageStyle==='island'
        ? <AtlasGameCard key={game.id} game={game} showRelease={showRelease} sizes="(max-width: 760px) 50vw, 240px"/>
        : <GameCard key={game.id} game={game} compact showRelease={showRelease} sizes="(max-width: 760px) 50vw, 240px"/>) }
    </div> : <div className="latest-games-empty"><Gamepad2 size={24}/><span>{emptyText}</span>{retry && <button className="button secondary" onClick={retry}>重试</button>}</div>}
  </section>;
}
